// extracted by mini-css-extract-plugin
module.exports = {"hits-wrap":"ModalProductHits_hits-wrap__vk1Gk","hits-header":"ModalProductHits_hits-header__It5vB","hits-items":"ModalProductHits_hits-items__DyHGm"};